/**
 * @generated SignedSource<<b3850648653dbfea22037e3ac6a86249>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type fileusagereason = "DEFAULT" | "RELEASED_BY_CUSTOMER" | "UNKNOWN" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type FileCard_file$data = {
  readonly annotationCount: {
    readonly totalCount: number;
  } | null;
  readonly fileUsage: fileusagereason;
  readonly filename: string;
  readonly flightId: string;
  readonly id: string;
  readonly isCji: boolean;
  readonly isUploaded: boolean | null;
  readonly kind: string;
  readonly metadata: {
    readonly core: {
      readonly durationUs: number | null;
    } | null;
  } | null;
  readonly sizeBytes: number | null;
  readonly thumbnailUrl: string | null;
  readonly uuid: string;
  readonly " $fragmentType": "FileCard_file";
};
export type FileCard_file$key = {
  readonly " $data"?: FileCard_file$data;
  readonly " $fragmentSpreads": FragmentRefs<"FileCard_file">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FileCard_file",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "kind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sizeBytes",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "thumbnailUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUploaded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileUsage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Metadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CoreMetadata",
          "kind": "LinkedField",
          "name": "core",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "durationUs",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "annotationCount",
      "args": null,
      "concreteType": "AnnotationConnection",
      "kind": "LinkedField",
      "name": "annotations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FlightDataFile",
  "abstractKey": null
};

(node as any).hash = "963bdbd3fde4531726923b5022aee3f0";

export default node;
